import superMeta from '../_CATEGORY_ROOT/metaCategoryRootNode.mjs'

export default {
    ...superMeta,
    name: '项目',
    type: 'CAT_ROOT_PRJ_DEP',
}
